import { render, staticRenderFns } from "./AccountApproval.vue?vue&type=template&id=9a7dbd24&"
import script from "./AccountApproval.vue?vue&type=script&lang=js&"
export * from "./AccountApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports